import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useModal } from "@animech/ui";
import { useTranslation } from "react-i18next";
import * as Styled from "./topbar-menu.style";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { OverlayData } from "store/types";
import { DownloadIcon } from "ui/components/elements/icons/download";
import { IconButton } from "ui/components/elements/icons/icon-button";
import { PdfIcon } from "ui/components/elements/icons/pdf";
import { Switch } from "ui/components/elements/switch";
import { Toggle } from "ui/components/elements/toggle";
import { UnitSwitch } from "ui/components/elements/unit-switch/unit-switch";
import { HowToUseModal } from "ui/components/modals/how-to-use";
/** Bundled via webpack CopyPlugin (`img/**` is copied to the build output). */
var basicUserManualPdfUrl = "img/docs/basic-manual-ovm-pro-3d.pdf";
/** Filename presented to the user when downloading. */
var basicUserManualPdfName = "Basic manual OVM Pro 3D tool - ENG_v1.pdf";
export var TopBarMenu = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var openModal = useModal();
    var systemPerformanceData = useAppSelector(selectors.selectActivePerformanceData);
    var hasReachedPartSecured = useAppSelector(selectors.selectHasReachedPartSecured);
    var showEnergySavePerformance = useAppSelector(selectors.selectShowEnergySave);
    var overlayData = useAppSelector(selectors.selectOverlayData);
    var selectedId = useAppSelector(selectors.selectSelectedId);
    var toggleShowPerformanceData = function () {
        dispatch(actions.setOverlayData(overlayData !== OverlayData.PERFORMANCE_DATA
            ? OverlayData.PERFORMANCE_DATA
            : undefined));
    };
    var toggleShowVacuumLevelData = function (value) {
        dispatch(actions.setOverlayData(value));
    };
    return (_jsxs(Styled.TopBarMenuRoot, { children: [_jsx(Styled.Header, { children: t("topbar.settings") }), _jsxs(Styled.Section, { children: [t("topbar.ovm_pro_3d"), _jsx(Styled.IconButtonWrapper, { children: _jsx(IconButton, { icon: "document-list", color: "inverted", appearance: "text", onClick: function () {
                                openModal(_jsx(HowToUseModal, {}));
                            }, variant: "rectangle" }) })] }), _jsxs(Styled.Section, { children: [t("topbar.basic_user_manual"), _jsxs(Styled.IconLinks, { children: [_jsx(Styled.IconLink, { href: basicUserManualPdfUrl, download: basicUserManualPdfName, "aria-label": t("topbar.download_manual"), title: t("topbar.download_manual"), children: _jsx(DownloadIcon, {}) }), _jsx(Styled.IconLink, { href: basicUserManualPdfUrl, target: "_blank", rel: "noopener noreferrer", "aria-label": t("topbar.open_manual"), title: t("topbar.open_manual"), children: _jsx(PdfIcon, {}) })] })] }), systemPerformanceData && !selectedId ? (_jsxs(_Fragment, { children: [_jsxs(Styled.Section, { children: [t("topbar.toggle_performance_data"), _jsx(Toggle, { checked: overlayData === OverlayData.PERFORMANCE_DATA, onChange: toggleShowPerformanceData })] }), _jsxs(Styled.Section, { children: [t("topbar.toggle_vacuum_data"), _jsx(Switch, { options: [
                                    {
                                        label: t("topbar.toggle_vacuum_data_off"),
                                        value: undefined,
                                        disabled: false,
                                    },
                                    {
                                        label: t("topbar.toggle_vacuum_data_ps"),
                                        value: OverlayData.VACUUM_LEVEL_PS,
                                        disabled: !hasReachedPartSecured,
                                    },
                                    {
                                        label: t("topbar.toggle_vacuum_data_es"),
                                        value: OverlayData.VACUUM_LEVEL_ES,
                                        disabled: !showEnergySavePerformance,
                                    },
                                ], value: overlayData === OverlayData.VACUUM_LEVEL_PS ||
                                    overlayData === OverlayData.VACUUM_LEVEL_ES
                                    ? overlayData
                                    : undefined, offIndex: 0, onValueChange: function (value) {
                                    return toggleShowVacuumLevelData(value);
                                } })] })] })) : null, _jsxs(Styled.Section, { children: [t("topbar.metric"), "/", t("topbar.imperial"), " ", _jsx(UnitSwitch, {})] })] }));
};
